import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
        marginRight: '10px',
        whiteSpace: 'nowrap',
        marginLeft: '30px',
    },
    tableContainer: {
        flex: '1 1 auto',
        maxHeight: 300,
        margin: `0 0 ${theme.spacing(3)} 0`,
        overflowY: 'hidden',
    },
    buttonMargin: {
        margin: '0 12px',
    },

}));

export default useStyles;
